const handleFileName = (
  fileName: string
): { formattedName: string; extension: string } => {
  let formattedName = fileName.substring(0, fileName.indexOf("."));
  const extension = fileName.substring(fileName.indexOf("."), fileName.length);
  if (formattedName.length > 25) {
    formattedName = `${formattedName.substring(
      0,
      15
    )}...${formattedName.substring(
      formattedName.length - 10,
      formattedName.length
    )}`;
  }
  return { formattedName, extension };
};

export default handleFileName;
